import { env } from "@/env.mjs";
import { Builder } from "@builder.io/react";
import { builder } from "@builder.io/sdk";

export class BuilderProvider {
  static initialize() {
    builder.canTrack = false;
    builder.init(env.NEXT_PUBLIC_BUILDER_API_KEY);
  }

  static getBuilder(): Builder {
    BuilderProvider.initialize();
    return builder;
  }
}
